import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';
import { useTranslation } from 'react-i18next';

const LanguagesField: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const { t: tForm } = useTranslation('form');
	const languages = customerForFullInfo?.languages.map((el) => tForm(el.languageName || '')).join(', ');

	return <FullInfoField label="languagesLabel" value={languages} />;
};

export default LanguagesField;
